import React from 'react';
import { NavLink } from 'react-router-dom';

const PageNavLocation = ({location}) => {

    const lat = location?.lat;
    const lon = location?.lon;

    if(!lat || !lon) {
        return <></>;
    }

    return (
        <nav>
            <ul className='flex justify-center gap-4 sm:gap-6 md:gap-8 sm:justify-start items-center text-xs sm:text-sm mt-8 border-b border-custom-charcoal'>

                <li className=''>
                    <NavLink 
                        to={`/location/forecast?lat=${lat}&lon=${lon}`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Forecast
                    </NavLink>
                </li>
                <li className=''>
                    <NavLink 
                        to={`/location/save?lat=${lat}&lon=${lon}`}
                        className={({isActive}) => `font-semibold py-4 border-b-2 block ${isActive ? 'border-custom-light-blue text-custom-light-blue' : 'border-transparent'}`}
                    >
                        Save Spot
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default PageNavLocation;